const fields = [
  {
    key: 'name',
    type: 'input',
    templateOptions: {
      label: 'name'
    }
  },
  {
    key: 'backgroundColor',
    type: 'color',
    templateOptions: {
      label: 'backgroundColor'
    }
  },
  {
    key: 'textColor',
    type: 'color',
    templateOptions: {
      label: 'textColor'
    }
  },
  {
    key: 'is_exhibition',
    type: 'boolean',
    templateOptions: {
      label: 'is_exhibition'
    }
  }
]

export default fields
